import { faGrip, faImages, faChevronLeft , faChevronRight, faPause, faPlay, faStar, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

export var faSolid = { faGrip, faImages, faChevronLeft , faChevronRight, faPause, faPlay, faStar, faXmark }
export var faRegular = { faStar: faStarRegular };
